module.exports = __webpack_public_path__ + "static/media/400105_02.43c9a80c.png";